import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_SA_TARGET:
      return { ...state, shiftDetails: action.payload };
    case ACTION_TYPES.FETCH_SA_REASON_CODES:
      return { ...state, schAttainmentReasonCodes: action.payload };
    case ACTION_TYPES.FETCH_SA_DAILY_INPUT_DETAILS:
      return { ...state, dailyInputDetails: action.payload };
    case ACTION_TYPES.REFRESH_SCH_ATTAINMENT_WIDGET:
      return { ...state, refreshSchAttainment: action.payload };
    case ACTION_TYPES.FETCH_SCH_ATTAINMENT_RUN_CHART: {
      return { ...state, runChartData: action.payload };
    }
    case ACTION_TYPES.FETCH_SCH_ATTAINMENT_MISS_REASON_CODE_FREQ: {
      return { ...state, missReasonCodeFrequency: action.payload };
    }
    case ACTION_TYPES.FETCH_QUESTIONARE_DATA:
      return { ...state, surveyData: action.payload };
    case ACTION_TYPES.FETCH_MULTI_SURVEY_DATA_BY_SURVEY_FILTER:
      return { ...state, surveyFilterData: action.payload };
    case ACTION_TYPES.FETCH_MULTI_SURVEY_SHIFT_DATA:
      return { ...state, surveyShiftDetails: action.payload };
    case ACTION_TYPES.FETCH_MULTI_SURVEY_SHIFT_QUESTION_DATA:
      return { ...state, surveyDailyQuestionDetails: action.payload };
    case ACTION_TYPES.FETCH_MULTI_SURVEY_PARETO_CHART_DATA: {
      return { ...state, paretoChartData: action.payload };
    }
    case ACTION_TYPES.FETCH_MULTI_SURVEY_RUN_CHART_DATA: {
      return { ...state, runChartData: action.payload };
    }
    case ACTION_TYPES.REFRESH_MULTI_SURVEY_WIDGET: {
      return { ...state, refreshMultiSurveyWidget: action.payload };
    }
    default:
      return state;
  }
};
